var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhoneAndroid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 34,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "phone_android_svg__a",
  width: 35,
  height: 34,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  stroke: "#F2F8FC",
  strokeWidth: 0.5,
  d: "M.551.25h33.5v33.5H.551z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#phone_android_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A78CD",
  stroke: "#F2F8FC",
  strokeWidth: 0.5,
  d: "M9.968 22.668v.25h14.667V8.251H9.968v14.417Zm.25 2.583h-.25v4.75h14.667v-4.75H10.218Zm-.25-19.583v.25h14.667V4.001H9.968v1.667Zm9.458 22.417h-4.25a.43.43 0 0 1-.319-.14.43.43 0 0 1-.139-.319.43.43 0 0 1 .14-.319.43.43 0 0 1 .318-.139h4.25a.43.43 0 0 1 .32.14c.097.097.139.2.139.318a.43.43 0 0 1-.14.32.43.43 0 0 1-.319.139Zm-9.208 4.25c-.712 0-1.316-.25-1.823-.759a2.48 2.48 0 0 1-.76-1.825v-25.5c0-.712.25-1.316.76-1.825a2.48 2.48 0 0 1 1.823-.758h14.167c.712 0 1.316.25 1.825.758.508.509.758 1.113.758 1.825v25.5c0 .713-.25 1.316-.758 1.825a2.48 2.48 0 0 1-1.825.759z"
}))));
export default SvgPhoneAndroid;